import 'promise-polyfill/src/polyfill';
import 'svgxuse';
import ObjectFitImages from 'object-fit-images';

import ParallaxMove from './base/script/parallax';
import Header from './new-blocks/header/header';
import FirstScreen from './new-blocks/first-screen/first-screen';
import PersonalForm from './new-blocks/personalForm/personalForm';
import About from './new-blocks/about/about';
import Gallery from './new-blocks/gallery/gallery';
import Stock from './new-blocks/stock/stock';
import Partners from './new-blocks/partners/partners';
import Prizes from './new-blocks/prizes/prizes';
import Catalog from './new-blocks/catalog/catalog';
import Location from './new-blocks/location/location';
import SectionObject from './new-blocks/sectionObject/sectionObject';
import FacingSection from './new-blocks/facing-section/facing-section';
import Map from './new-blocks/map/map';
import Projects from './new-blocks/projects/projects';
import Popup from './new-blocks/popup/popup';
import PopupCallback from './new-blocks/popup/callback/popup-callback';
import PopupOffer from './new-blocks/popup/offer/popup-offer';
import Calculator from './new-blocks/calculator/calculator';
import TopProjects from './new-blocks/topProjects/topProjects';
import FacingSectionHorizontal from './new-blocks/facing-section/horizontal/facing-section-horizontal';
import GalleryPlate from './new-blocks/gallery/plate/gallery-plate';
import { animation } from './new-blocks/animations/animations';

import recaptcha from './base/script/recaptcha';
import Infrastructure from './new-blocks/infrastructure/infrastructure';

require('custom-event-polyfill');
require('lazysizes');
require('./new-theme.scss');

window.bodyLock = require('body-scroll-lock');

ObjectFitImages(null, { watchMQ: true });

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--small': '(max-width: 767px)',
  '--medium': '(min-width: 768px) and (max-width: 1279px)',
  '--large': '(min-width: 1280px)',
};
window.lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig.expand = 600;
window.lazySizesConfig.expFactor = 1;

window.debounce = (f, ms) => {
  let timer = null;

  return (...args) => {
    const onComplete = () => {
      f.apply(this, args);
      timer = null;
    };

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(onComplete, ms);
  };
};

if (window.captchaSitekey) {
  recaptcha.setKey(window.captchaSitekey);
  window.recaptchaLoad = () => {
    recaptcha.load();
  };
}

window.intlTelInputGlobals.loadUtils('utils.js').then(() => {
  window.dispatchEvent(new window.CustomEvent('intlTelUtilsLoad'));
}).catch(error => new Error(error));


const mq = document.querySelector('[data-marquiz-id]');
if (mq) {
  const stringId = mq.getAttribute('data-marquiz-id');
  ((w, d, s, o) => {
    const j = d.createElement(s);
    j.async = true;
    j.src = '//script.marquiz.ru/v2.js';
    j.onload = () => {
      if (document.readyState !== 'loading') {
        window.Marquiz.init(o);
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          window.Marquiz.init(o);
        });
      }
    };
    d.head.insertBefore(j, d.head.firstElementChild);
  })(window, document, 'script', {
    host: '//quiz.marquiz.ru',
    region: 'eu',
    id: stringId,
    autoOpen: false,
    autoOpenFreq: 'once',
    openOnExit: false,
    disableOnMobile: false,
  });
  // eslint-disable-next-line
    (function(t, p) {window.Marquiz ? Marquiz.add([t, p]) : document.addEventListener('marquizLoaded', function() {Marquiz.add([t, p])})})('Inline', {id: stringId, buttonText: 'Пройти тест', bgColor: '#f00045', textColor: '#ffffff', rounded: true, shadow: 'rgba(240, 0, 69, 0.5)', blicked: true, buttonOnMobile: true});
}

Header();
FirstScreen();
PersonalForm();
About();
Stock();
Map();
Partners();
Prizes();
Catalog();
SectionObject();
TopProjects();
FacingSection();
PopupCallback();
Calculator();
PopupOffer();
FacingSectionHorizontal();
GalleryPlate();

window.closeMenu = (menu, wrp) => {
  window.bodyLock.enableBodyScroll(wrp);
  menu.classList.remove('header-menu--show');

  setTimeout(() => {
    menu.classList.remove('header-menu--open');
  }, 400);
};

new ParallaxMove();

const menu = document.querySelector('.header-menu');
[].slice.call(document.querySelectorAll('.header-menu__link')).forEach((btn) => {
  if (btn) {
    btn.addEventListener('click', () => {
      const menuWrp = menu.querySelector('.header-menu__wrp');
      if (menu.classList.contains('header-menu--open')) {
        window.closeMenu(menu, menuWrp);
      }
    });
  }
});

[].slice.call(document.querySelectorAll('.gallery')).forEach((galleryBlock) => {
  if (galleryBlock) {
    new Gallery(galleryBlock);
  }
});

[].slice.call(document.querySelectorAll('.location')).forEach((elem) => {
  if (elem) {
    new Location(elem);
  }
});

const callbackPopup = new Popup({
  popup: '#callback',
});

window.callbackPopup = new Popup({
  popup: '#callback',
  type: 'new',
});

const header = document.querySelector('.header');
const successPopup = document.querySelector('.popup-success');
const successCloseBtn = successPopup.querySelector('.popup-success__back-link');
window.successPopup = new Popup({
  overlay: successPopup,
  popup: '#popup-success',
});

window.openSuccessPopup = () => {
  window.successPopup.open();
  header.classList.add('header--white');
};

if (successCloseBtn) {
  successCloseBtn.addEventListener('click', (e) => {
    e.preventDefault();

    window.successPopup.close();
    if (header.getAttribute('data-keepwhite') !== 'true') {
      header.classList.remove('header--white');
    }
  });
}

[].slice.call(document.querySelectorAll('[data-popup]')).forEach((button) => {
  if (button) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (button.dataset.type && button.dataset.type === 'presentation') {
        const callbackPopupPresentation = new Popup({
          popup: '#callback',
          type: 'presentation',
        });
        callbackPopupPresentation.open();
      } else if (button.dataset.type && button.dataset.type === 'calculator') {
        const callbackPopupCalculator = new Popup({
          popup: '#callback',
          type: 'calculator',
        });
        callbackPopupCalculator.open();
      } else if (button.dataset.type && button.dataset.type === 'new') {
        const callbackPopupNew = new Popup({
          popup: '#callback',
          type: 'new',
        });
        window.LCDPopupData = {
          id: button.dataset.id,
          title: button.dataset.title,
        };
        callbackPopupNew.open();
      } else {
        callbackPopup.open();
      }
    });
  }
});

[].slice.call(document.querySelectorAll('.projects')).forEach((el) => {
  if (el) {
    new Projects(el);
  }
});

[].slice.call(document.querySelectorAll('.infrastructure')).forEach((el) => {
  if (el) {
    new Infrastructure(el);
  }
});

animation();



// WEBPACK FOOTER //
// ./new-theme.js